export default "__VITE_ASSET__DZkuLbn2__"